// This file was autogenerated. Do not edit directly.

import { lightThemeTokens } from './lightThemeTokens';

export const cssVariablesLightTheme = {
    '--background-contrast-high': lightThemeTokens.backgroundContrastHigh,
    '--background-contrast-inverse': lightThemeTokens.backgroundContrastInverse,
    '--background-contrast-medium': lightThemeTokens.backgroundContrastMedium,
    '--background-contrast-none': lightThemeTokens.backgroundContrastNone,
    '--background-data-blue': lightThemeTokens.backgroundDataBlue,
    '--background-data-cyan': lightThemeTokens.backgroundDataCyan,
    '--background-data-purple': lightThemeTokens.backgroundDataPurple,
    '--background-data-seafoam': lightThemeTokens.backgroundDataSeafoam,
    '--background-data-yellow': lightThemeTokens.backgroundDataYellow,
    '--background-interactive-negative-hovered': lightThemeTokens.backgroundInteractiveNegativeHovered,
    '--background-interactive-negative-pressed': lightThemeTokens.backgroundInteractiveNegativePressed,
    '--background-interactive-negative-resting': lightThemeTokens.backgroundInteractiveNegativeResting,
    '--background-interactive-positive-hovered': lightThemeTokens.backgroundInteractivePositiveHovered,
    '--background-interactive-positive-pressed': lightThemeTokens.backgroundInteractivePositivePressed,
    '--background-interactive-positive-resting': lightThemeTokens.backgroundInteractivePositiveResting,
    '--background-interactive-prominent-hovered': lightThemeTokens.backgroundInteractiveProminentHovered,
    '--background-interactive-prominent-pressed': lightThemeTokens.backgroundInteractiveProminentPressed,
    '--background-interactive-prominent-resting': lightThemeTokens.backgroundInteractiveProminentResting,
    '--background-status-caution': lightThemeTokens.backgroundStatusCaution,
    '--background-status-disabled': lightThemeTokens.backgroundStatusDisabled,
    '--background-status-info': lightThemeTokens.backgroundStatusInfo,
    '--background-status-negative': lightThemeTokens.backgroundStatusNegative,
    '--background-status-neutral': lightThemeTokens.backgroundStatusNeutral,
    '--background-status-positive': lightThemeTokens.backgroundStatusPositive,
    '--background-status-prominent': lightThemeTokens.backgroundStatusProminent,
    '--base-neutral-hovered': lightThemeTokens.baseNeutralHovered,
    '--base-neutral-pressed': lightThemeTokens.baseNeutralPressed,
    '--base-neutral-resting': lightThemeTokens.baseNeutralResting,
    '--graphic-contrast-high': lightThemeTokens.graphicContrastHigh,
    '--graphic-contrast-inverse': lightThemeTokens.graphicContrastInverse,
    '--graphic-contrast-low': lightThemeTokens.graphicContrastLow,
    '--graphic-contrast-medium': lightThemeTokens.graphicContrastMedium,
    '--graphic-data-blue': lightThemeTokens.graphicDataBlue,
    '--graphic-data-cyan': lightThemeTokens.graphicDataCyan,
    '--graphic-data-purple': lightThemeTokens.graphicDataPurple,
    '--graphic-data-seafoam': lightThemeTokens.graphicDataSeafoam,
    '--graphic-data-yellow': lightThemeTokens.graphicDataYellow,
    '--graphic-interactive-negative-hovered': lightThemeTokens.graphicInteractiveNegativeHovered,
    '--graphic-interactive-negative-pressed': lightThemeTokens.graphicInteractiveNegativePressed,
    '--graphic-interactive-negative-resting': lightThemeTokens.graphicInteractiveNegativeResting,
    '--graphic-interactive-neutral-hovered': lightThemeTokens.graphicInteractiveNeutralHovered,
    '--graphic-interactive-neutral-pressed': lightThemeTokens.graphicInteractiveNeutralPressed,
    '--graphic-interactive-neutral-resting': lightThemeTokens.graphicInteractiveNeutralResting,
    '--graphic-interactive-prominent-hovered': lightThemeTokens.graphicInteractiveProminentHovered,
    '--graphic-interactive-prominent-pressed': lightThemeTokens.graphicInteractiveProminentPressed,
    '--graphic-interactive-prominent-resting': lightThemeTokens.graphicInteractiveProminentResting,
    '--graphic-status-caution': lightThemeTokens.graphicStatusCaution,
    '--graphic-status-disabled': lightThemeTokens.graphicStatusDisabled,
    '--graphic-status-info': lightThemeTokens.graphicStatusInfo,
    '--graphic-status-negative': lightThemeTokens.graphicStatusNegative,
    '--graphic-status-neutral': lightThemeTokens.graphicStatusNeutral,
    '--graphic-status-positive': lightThemeTokens.graphicStatusPositive,
    '--graphic-status-prominent': lightThemeTokens.graphicStatusProminent,
    '--text-contrast-high': lightThemeTokens.textContrastHigh,
    '--text-contrast-inverse': lightThemeTokens.textContrastInverse,
    '--text-contrast-low': lightThemeTokens.textContrastLow,
    '--text-contrast-medium': lightThemeTokens.textContrastMedium,
    '--text-contrast-minimum': lightThemeTokens.textContrastMinimum,
    '--text-data-blue': lightThemeTokens.textDataBlue,
    '--text-data-cyan': lightThemeTokens.textDataCyan,
    '--text-data-purple': lightThemeTokens.textDataPurple,
    '--text-data-seafoam': lightThemeTokens.textDataSeafoam,
    '--text-data-yellow': lightThemeTokens.textDataYellow,
    '--text-interactive-negative-hovered': lightThemeTokens.textInteractiveNegativeHovered,
    '--text-interactive-negative-pressed': lightThemeTokens.textInteractiveNegativePressed,
    '--text-interactive-negative-resting': lightThemeTokens.textInteractiveNegativeResting,
    '--text-interactive-neutral-hovered': lightThemeTokens.textInteractiveNeutralHovered,
    '--text-interactive-neutral-pressed': lightThemeTokens.textInteractiveNeutralPressed,
    '--text-interactive-neutral-resting': lightThemeTokens.textInteractiveNeutralResting,
    '--text-interactive-prominent-hovered': lightThemeTokens.textInteractiveProminentHovered,
    '--text-interactive-prominent-pressed': lightThemeTokens.textInteractiveProminentPressed,
    '--text-interactive-prominent-resting': lightThemeTokens.textInteractiveProminentResting,
    '--text-status-caution': lightThemeTokens.textStatusCaution,
    '--text-status-disabled': lightThemeTokens.textStatusDisabled,
    '--text-status-info': lightThemeTokens.textStatusInfo,
    '--text-status-negative': lightThemeTokens.textStatusNegative,
    '--text-status-neutral': lightThemeTokens.textStatusNeutral,
    '--text-status-positive': lightThemeTokens.textStatusPositive,
    '--text-status-prominent': lightThemeTokens.textStatusProminent,
};
    